// extracted by mini-css-extract-plugin
export default {"warning":"NotFound_warning__k3Dyl"};